import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {HttpStatusCodes, ArcCheckLstTypes} from '../.././util/uiconstants';
import arcChecklistMergeNormalizer from './arcChecklistMergeNormalizer';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      storeIgua.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function arcChecksListReducer(state = initialState.arcChecksList, action) {
	switch (action.type) {
		case types.GET_ARCTIMELINE_CHECKLIST: {
			const {personInCharge = null} = state;
			if (personInCharge) return {...action.response, personInCharge};
			return action.response;
		}
		case types.UPDATE_ARCTIMELINE_CHECKLIST: {
			let newState = _.cloneDeep(state);
			switch (action.typeId) {
				case ArcCheckLstTypes.AccuracyEngagementDates:
					newState.engagementDatesModel.checklistModel.isChecked = action.response.isChecked;
					break;
				case ArcCheckLstTypes.AccuracyClientCodes:
					newState.clientCodeModel.isChecked = action.response.isChecked;
					break;
				case ArcCheckLstTypes.AccuracyEngagementCodes:
					newState.engagementCodesModel.checklistModel.isChecked = action.response.isChecked;
					break;
				case ArcCheckLstTypes.UnlinkGroupEvidence:
					newState.unlinkGroupEvidenceModel.isChecked = action.response.isChecked;
					break;
				case ArcCheckLstTypes.ReportType:
					newState.reportTypeModel.checklistModel.isChecked = action.response.isChecked;
					break;
				case ArcCheckLstTypes.FinalizedHardEvidence:
					newState.finalizedHardEvidenceModel.checklistModel.isChecked = action.response.isChecked;
					break;
				case ArcCheckLstTypes.ReviewProtectedDocuments:
					newState.protectedDocumentsModel.isChecked = action.response.isChecked;
					break;
				case ArcCheckLstTypes.ReviewTemporaryFilesModifiedAfterRRD:
					newState.reviewTemporaryFilesModifiedAfterRRDModel.isChecked = action.response.isChecked;
					break;
				case ArcCheckLstTypes.ReviewDeletedFilesModifiedAfterRRD:
					newState.reviewDeletedFilesModifiedAfterRRDModel.isChecked = action.response.isChecked;
					break;
			}

			return newState;
		}
		case types.UPDATE_CHECKLIST_TOGGLE: {
			let newState = _.cloneDeep(state);
			// TODO: add pending types
			switch (action.typeId) {
				case ArcCheckLstTypes.UnlinkGroupEvidence:
					newState.unlinkGroupEvidenceModel.isChecked = action.isChecked;
					break;
				case ArcCheckLstTypes.EngagementProfileSubmit:
					newState.ProfileChecklistModel.isChecked = action.isChecked;
					break;
			}
			return newState;
		}
		case types.UPDATE_CHECKLIST_ACTIVITY_STATUS: {
			let newState = _.cloneDeep(state);
			if (newState && newState.unlinkSharedEvidenceModel) {
				newState.unlinkSharedEvidenceModel.statusId = action.engagementActivityStatusId;
				return newState;
			}

			return state;
		}
		case types.GET_ARCTIMELINE_VALIDATIONS:
		case types.GET_ARCTIMELINE_GROUP_VALIDATION: {
			if (!action.response) return state;
			return arcChecklistMergeNormalizer(state, action.response);
		}
		default:
			return state;
	}
}
